// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-dialog-modal.overlay-background-react {
  z-index: 1032;
}
.confirmation-dialog {
  max-width: 480px;
}
.confirmation-dialog__header {
  position: relative;
  padding: 2.4rem 2.4rem 0;
  padding-right: 5.9rem;
}
.confirmation-dialog__header .overlay-cancel-mark {
  top: 2.4rem;
  right: 2.4rem;
  width: 1.7em;
  height: 1.7em;
}
.confirmation-dialog__title-block {
  display: flex;
  align-items: stretch;
  gap: 1.2rem;
  min-width: 0;
}
.confirmation-dialog__title-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  width: 45px;
  border-radius: 50%;
  color: #CC3928;
  background-color: #f6efef;
  padding: 12px;
  font-size: 18px;
}
.confirmation-dialog__title-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.4rem;
}
.confirmation-dialog__title {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 500;
  color: #252B37;
}
.confirmation-dialog__subtitle {
  font-size: 1.4rem;
  color: #535862;
}
.confirmation-dialog__main {
  padding-top: 1.6rem;
  padding-bottom: 0.8rem;
}
.confirmation-dialog__message,
.confirmation-dialog__question {
  margin: 0 0 1.2rem;
  font-size: 1.4rem;
  line-height: 1.55;
  color: #252B37;
}
.confirmation-dialog__message:last-child,
.confirmation-dialog__question:last-child {
  margin-bottom: 0;
}
.confirmation-dialog__question {
  margin-top: 0.4rem;
}
.confirmation-dialog__footer {
  padding: 1.6rem 2.4rem 2.4rem;
}
.confirmation-dialog__footer .overlay-cancel.btn-link {
  display: inline-flex !important;
}
.confirmation-dialog__confirm--danger {
  background-color: #CC3928;
  border-color: #CC3928;
  color: #ffffff;
}
.confirmation-dialog__confirm--danger:hover,
.confirmation-dialog__confirm--danger:focus {
  background-color: #b23223;
  border-color: #b23223;
  color: #ffffff;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/core/ConfirmationDialog/index.less"],"names":[],"mappings":"AAEA;EACI,aAAA;ACDJ;ADIA;EACI,gBAAA;ACFJ;ADII;EACI,kBAAA;EACA,wBAAA;EACA,qBAAA;ACFR;ADDI;EAMQ,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;ACFZ;ADKI;EACI,aAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;ACHR;ADMI;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,eAAA;ACJR;ADOI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;ACLR;ADQI;EACI,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ACNR;ADSI;EACI,iBAAA;EACA,cAAA;ACPR;ADUI;EACI,mBAAA;EACA,sBAAA;ACRR;ADWI;;EAEI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;ACTR;ADWQ;;EACI,gBAAA;ACRZ;ADYI;EACI,kBAAA;ACVR;ADaI;EACI,6BAAA;ACXR;ADUI;EAIQ,+BAAA;ACXZ;ADeI;EACI,yBAAA;EACA,qBAAA;EACA,cAAA;ACbR;ADeQ;;EAEI,yBAAA;EACA,qBAAA;EACA,cAAA;ACbZ;AACA,oCAAoC","sourcesContent":["@import '../../../less/variables.less';\n\n.confirmation-dialog-modal.overlay-background-react {\n    z-index: @confirmation-modal-z-index;\n}\n\n.confirmation-dialog {\n    max-width: 480px;\n\n    &__header {\n        position: relative;\n        padding: 2.4rem 2.4rem 0;\n        padding-right: (2.4rem + 3.5em);\n\n        .overlay-cancel-mark {\n            top: 2.4rem;\n            right: 2.4rem;\n            width: 1.7em;\n            height: 1.7em;\n        }\n    }\n    &__title-block {\n        display: flex;\n        align-items: stretch;\n        gap: 1.2rem;\n        min-width: 0;\n    }\n\n    &__title-icon {\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 45px;\n        width: 45px;\n        border-radius: @radius-round;\n        color: @primary-600;\n        background-color: @red-light;\n        padding: 12px;\n        font-size: 18px;\n    }\n\n    &__title-text {\n        min-width: 0;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        gap: 0.4rem;\n    }\n\n    &__title {\n        margin: 0;\n        font-size: 1.6rem;\n        font-weight: @font-weight-semi-bold;\n        color: @secondary-800;\n    }\n\n    &__subtitle {\n        font-size: 1.4rem;\n        color: @secondary-600;\n    }\n\n    &__main {\n        padding-top: 1.6rem;\n        padding-bottom: 0.8rem;\n    }\n\n    &__message,\n    &__question {\n        margin: 0 0 1.2rem;\n        font-size: 1.4rem;\n        line-height: 1.55;\n        color: @secondary-800;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n\n    &__question {\n        margin-top: 0.4rem;\n    }\n\n    &__footer {\n        padding: 1.6rem 2.4rem 2.4rem;\n\n        .overlay-cancel.btn-link {\n            display: inline-flex !important;\n        }\n    }\n\n    &__confirm--danger {\n        background-color: @primary-600;\n        border-color: @primary-600;\n        color: @white;\n\n        &:hover,\n        &:focus {\n            background-color: darken(@primary-600, 6%);\n            border-color: darken(@primary-600, 6%);\n            color: @white;\n        }\n    }\n}\n",".confirmation-dialog-modal.overlay-background-react {\n  z-index: 1032;\n}\n.confirmation-dialog {\n  max-width: 480px;\n}\n.confirmation-dialog__header {\n  position: relative;\n  padding: 2.4rem 2.4rem 0;\n  padding-right: 5.9rem;\n}\n.confirmation-dialog__header .overlay-cancel-mark {\n  top: 2.4rem;\n  right: 2.4rem;\n  width: 1.7em;\n  height: 1.7em;\n}\n.confirmation-dialog__title-block {\n  display: flex;\n  align-items: stretch;\n  gap: 1.2rem;\n  min-width: 0;\n}\n.confirmation-dialog__title-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 45px;\n  width: 45px;\n  border-radius: 50%;\n  color: #CC3928;\n  background-color: #f6efef;\n  padding: 12px;\n  font-size: 18px;\n}\n.confirmation-dialog__title-text {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.4rem;\n}\n.confirmation-dialog__title {\n  margin: 0;\n  font-size: 1.6rem;\n  font-weight: 500;\n  color: #252B37;\n}\n.confirmation-dialog__subtitle {\n  font-size: 1.4rem;\n  color: #535862;\n}\n.confirmation-dialog__main {\n  padding-top: 1.6rem;\n  padding-bottom: 0.8rem;\n}\n.confirmation-dialog__message,\n.confirmation-dialog__question {\n  margin: 0 0 1.2rem;\n  font-size: 1.4rem;\n  line-height: 1.55;\n  color: #252B37;\n}\n.confirmation-dialog__message:last-child,\n.confirmation-dialog__question:last-child {\n  margin-bottom: 0;\n}\n.confirmation-dialog__question {\n  margin-top: 0.4rem;\n}\n.confirmation-dialog__footer {\n  padding: 1.6rem 2.4rem 2.4rem;\n}\n.confirmation-dialog__footer .overlay-cancel.btn-link {\n  display: inline-flex !important;\n}\n.confirmation-dialog__confirm--danger {\n  background-color: #CC3928;\n  border-color: #CC3928;\n  color: #ffffff;\n}\n.confirmation-dialog__confirm--danger:hover,\n.confirmation-dialog__confirm--danger:focus {\n  background-color: #b23223;\n  border-color: #b23223;\n  color: #ffffff;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
